import clsx from "clsx";
import { useT } from "../i18n";

export type RiskLevel = 1 | 2 | 3 | 4;

/** Maps the API's risk words / scores to the 4-step scale. */
export function riskLevelOf(risk: string | number | null | undefined): RiskLevel {
  if (typeof risk === "number") return Math.min(4, Math.max(1, Math.round(risk))) as RiskLevel;
  switch ((risk ?? "").toLowerCase()) {
    case "critical": return 4;
    case "high": return 3;
    case "medium": return 2;
    default: return 1;
  }
}

/**
 * Risk is a property of access, not a state: a 4-bar meter (6/9/12/15 px), always with the word (§2.4).
 * Bars are ink for low/medium, warn for high, bad for critical. `sentence` adds what the access allows
 * ("can release money") – the portal shows risk only from High up.
 */
export function RiskMeter({ level, label = true, sentence, className }: { level: RiskLevel; label?: boolean; sentence?: string; className?: string }) {
  const t = useT();
  const word = t(`risk.${level}`);
  return (
    <span className={clsx("inline-flex items-center gap-1.5 whitespace-nowrap text-[12.5px] font-semibold text-fg-2", className)}>
      <span className={clsx("iga-risk", `iga-risk-${level}`)} role="img" aria-label={t("risk.label", { level: word })}><i /><i /><i /><i /></span>
      {label && <span>{word}{sentence ? <span className="font-normal text-fg-3">: {sentence}</span> : null}</span>}
    </span>
  );
}
